import { render, staticRenderFns } from "./CreateRolesForCaseType.vue?vue&type=template&id=312d7ece&scoped=true&"
import script from "./CreateRolesForCaseType.vue?vue&type=script&lang=js&"
export * from "./CreateRolesForCaseType.vue?vue&type=script&lang=js&"
import style0 from "./CreateRolesForCaseType.vue?vue&type=style&index=0&id=312d7ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d7ece",
  null
  
)

export default component.exports